import { FunctionComponent as F, useState } from 'react';
import { Stack, Typography, TextField, Box, DialogContent, DialogTitle, Dialog } from '@mui/material';
import Button from '../UI/Button/Button';
import { IFundraisers, postNewFundraiser } from '../../core/http/fundraiser';
import { validateFundraiserTitle, validateFundraiserRecipient, validateUrl } from '../../utils/validate';


interface IProps
{
  fundraisers: IFundraisers[];
  handleSubmit: (fundraiserId: number, title: string, recipientName: string, url: string) => void;
  closeDialog: () => void;
}

const NewFundraiser: F<IProps> = (props: IProps) =>
{
  const initialMessage = "Enter fundraiser details";
  const [message, setMessage] = useState(initialMessage);

  const [title, setTitle] = useState('');
  const [titleError, setTitleError] = useState(false);
  const [recipientName, setRecipientName] = useState('');
  const [recipientNameError, setRecipientNameError] = useState(false);
  const [url, setUrl] = useState("");
  const [urlError, setUrlError] = useState(false);


  function handleSubmit()
  {
    if(!props.fundraisers.every(f => f.url !== url))
    {
      setMessage("There is already a fundraiser with this URL");
    }
    else if(title.length === 0 || recipientName.length === 0 || url.length === 0)
    {
      setMessage("Please enter Title, Recipient and URL");
    }
    else if(urlError)
    {
      setMessage(" URL not valid.\r Must start with http:// or https:// ");
    }
    else
    {
      postNewFundraiser(title, recipientName, url)
        .then(data =>
        {
          if(!data?.fundraiserId)
            return;

          props.handleSubmit(data.fundraiserId, title, recipientName, url);
        });
    }
  }

  function handleTitleChange(event: React.ChangeEvent<HTMLInputElement>)
  {
    setTitle(event.target.value);
    setTitleError(!validateFundraiserTitle(event.target.value));
    setMessage(initialMessage);
  }

  function handleRecipientNameChange(event: React.ChangeEvent<HTMLInputElement>)
  {
    setRecipientName(event.target.value);
    setRecipientNameError(!validateFundraiserRecipient(event.target.value));
    setMessage(initialMessage);
  }

  function handleUrlChange(event: React.ChangeEvent<HTMLInputElement>)
  {
    setUrl(event.target.value);
    setUrlError(!validateUrl(event.target.value));
    setMessage(initialMessage);
  }


  return(
    <Dialog
      maxWidth='md'
      PaperProps={{ sx: { p: '15px', textAlign: 'center', width: 400 }}}
      open={true}
      onClose={props.closeDialog}>

      <DialogTitle sx={{ fontSize: '24px' }}>New Fundraiser</DialogTitle>
      <DialogContent>
        <Stack sx={{  pb: 3 }} spacing={2}>
          <Typography variant='body2' sx={{ paddingBottom: '10px' }}>
            {message} <br/>
          </Typography>
          <TextField
            fullWidth
            size='small'
            type='text'
            label='Title'
            value={title}
            onChange={handleTitleChange}
            error={titleError}/>
          <TextField
            fullWidth
            size='small'
            type='text'
            label='Recipient'
            value={recipientName}
            onChange={handleRecipientNameChange}
            error={recipientNameError}/>
          <TextField
            fullWidth
            size='small'
            type='text'
            label='URL'
            value={url}
            onChange={handleUrlChange}
            error={urlError}/>
          <Box sx={{ margin: 0 }}>
            <Button
              onClick={handleSubmit}
              label='Submit'/>
            <Box sx={{ display: 'inline', pl: '14px' }} />
          </Box>
        </Stack>
      </DialogContent>
    </Dialog> );
};

export default NewFundraiser;
